import React from 'react';
import PropTypes from 'prop-types';

const LoadMore = ({ className }) => {
    return (
        <svg 
            className={className} 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" // No fill color for the SVG
        >
            <path 
                d="M9.84649 3.38664C9.29066 3.21331 8.67733 3.09998 8.0001 3.09998C4.93983 3.09998 2.46094 5.68664 2.46094 8.87998C2.46094 12.08 4.93983 14.6666 8.0001 14.6666C11.0604 14.6666 13.5393 12.08 13.5393 8.88664C13.5393 7.69998 13.1943 6.59331 12.6065 5.67331" 
                stroke="#A67C21" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none" // Ensure no fill in the path
            />
            <path 
                d="M10.6389 3.54671L8.79248 1.33337" 
                stroke="#A67C21" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none" // Ensure no fill in the path
            />
            <path 
                d="M10.6389 3.54663L8.48584 5.18663" 
                stroke="#A67C21" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none" // Ensure no fill in the path
            />
        </svg>
    );
};

LoadMore.propTypes = {
    className: PropTypes.string, // Optional: allows passing custom classes
};

LoadMore.defaultProps = {
    className: '', // Default to an empty string
};

export default LoadMore;
